'use client'
import React, { useEffect, useState } from 'react'
import PaginationPluto from './Pagination'
import { canUsePagination, numberWithCommas } from '../utils'
import { socket } from '../Containers/MainContainer'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import SweetAlert from 'react-bootstrap-sweetalert'
import { set } from 'nprogress'
import PlutoMenu from './PlutoMenu'
import VerifyAdmin from './PlutoVerify'
import { Link } from 'react-router-dom'


function PlutoPendingOffers(props) {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [today, setToday] = useState(undefined)
    const [rank, setRank] = useState(0)
    const [alert, setAlert] = useState({ show: false, user_id: -1, offer_id: -1, name: '' })
    useEffect(() => {
        socket.on('response_get_admin_pending', (data) => {
            setEarnings(data.withdrawals)
            setPageNumber(Math.ceil(data.withdrawalsLength / 5))
            setUserProfile(data)
            canUsePagination(true)
            setRank(data.rank)
        })
        socket.on('reTakeUsersPendingDet', (data) => {
            socket.emit('getPendingOffersAdmin', {
                page,
                for_user: props.second_page
            })
        })
        socket.emit('getPendingOffersAdmin', {
            page,
            for_user: props.second_page
        })
    }, [])

    const styles = {
        pageContainer: {
            color: '#e6edf3',
            padding: '24px',
            background: '#0d1117',
            minHeight: '100vh',
        },
        filterButtonRow: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            width: '100%',
            gap: '10px',
            marginBottom: '20px',
        },
        filterButton: {
            padding: '8px 16px',
            borderRadius: '8px',
            border: '1px solid #30363d',
            background: '#161b22',
            color: '#c9d1d9',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: '500',
            minWidth: '100px',
            textAlign: 'center',
        },
        statsRow: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '16px',
            marginBottom: '24px',
        },
        statCard: (borderColor) => ({
            background: '#161b22',
            border: '1px solid #21262d',
            borderLeft: `3px solid ${borderColor}`,
            borderRadius: '12px',
            padding: '16px 24px',
            minWidth: '160px',
        }),
        statValue: {
            fontSize: '22px',
            fontWeight: '700',
            color: '#e6edf3',
            margin: '0 0 4px 0',
        },
        statLabel: {
            fontSize: '12px',
            color: '#8b949e',
            margin: 0,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
        },
        tableContainer: {
            overflow: 'auto',
            margin: '0 auto',
            padding: '20px',
            marginBottom: '20px',
            background: '#161b22',
            border: '1px solid #21262d',
            borderRadius: '12px',
        },
        tableTitle: {
            color: '#e6edf3',
            fontWeight: 'bold',
            fontSize: '16px',
            marginBottom: '16px',
        },
        tableHeaderRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '10px 0',
            borderBottom: '1px solid #21262d',
            background: '#161b22',
        },
        tableHeaderCell: (minWidth, maxWidth) => ({
            minWidth,
            maxWidth: maxWidth || undefined,
            fontSize: '11px',
            fontWeight: '600',
            color: '#8b949e',
            textTransform: 'uppercase',
            letterSpacing: '0.8px',
        }),
        tableRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '10px 0',
            borderBottom: '1px solid #21262d',
            color: '#c9d1d9',
            fontSize: '13px',
        },
        tableCell: (minWidth) => ({
            minWidth,
            color: '#c9d1d9',
            fontSize: '13px',
        }),
        tableCellPrimary: (minWidth) => ({
            minWidth,
            textAlign: 'left',
            color: '#e6edf3',
            fontWeight: '500',
            fontSize: '13px',
        }),
        actionButton: (borderColor, bgColor, textColor) => ({
            minWidth: '100px',
            maxWidth: '100px',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '11px',
            background: bgColor,
            border: `1px solid ${borderColor}`,
            color: textColor,
            borderRadius: '6px',
            textDecoration: 'none',
            cursor: 'pointer',
            fontWeight: '500',
        }),
        sweetAlertStyle: {
            backgroundColor: '#161b22',
            color: '#e6edf3',
            border: '1px solid #30363d',
            borderRadius: '12px',
        },
        sweetAlertCancelBtn: {
            color: '#8b949e',
            textDecoration: 'none',
        },
        sweetAlertConfirmBtn: {
            border: 'none',
            boxShadow: 'none',
            padding: '8px 18px',
            backgroundColor: '#238636',
            color: '#ffffff',
            borderRadius: '6px',
        },
    }

    return (
        <SkeletonTheme baseColor="#161b22" highlightColor="#21262d">
            <SweetAlert
                show={alert.show}
                title={alert.title}
                onConfirm={function () {
                    socket.emit('adminAction', {
                        action: 'releaseOfferAdmin',
                        user_id: alert.user_id,
                        offer_id: alert.offer_id,
                    })
                    setAlert({ ...alert, show: false })
                }}
                style={styles.sweetAlertStyle}
                cancelBtnText="Not now"
                confirmBtnText="Proceed"
                showCancel={true}
                cancelBtnStyle={styles.sweetAlertCancelBtn}
                confirmBtnStyle={styles.sweetAlertConfirmBtn}
                onCancel={function () { setAlert({ show: false, user_id: '', offer_id: '', name: '' }) }}
            >
                <>
                    <h3 style={{ color: '#e6edf3' }}>Do you want to release this offer?</h3>
                    <p style={{ color: '#c9d1d9' }}>Offer_name:{alert.name}</p>
                    <p style={{ color: '#c9d1d9' }}>Offer_id:{alert.offer_id}</p>
                    <p style={{ color: '#c9d1d9' }}>User_id:{alert.user_id}</p>
                </>

            </SweetAlert>
            <div style={styles.pageContainer}>
                <div style={styles.filterButtonRow}>
                    <div style={styles.filterButton} onClick={() => {
                        setToday(true)
                        socket.emit('getPendingOffersAdmin', {
                            page,
                            for_user: props.second_page,
                            today: true,
                        })
                    }}>Today</div>
                    <div style={styles.filterButton} onClick={() => {
                        setToday(undefined)
                        socket.emit('getPendingOffersAdmin', {
                            page,
                            for_user: props.second_page,
                        })
                    }}>All</div>
                </div>

                <div style={styles.statsRow}>
                    {userProfile.pendingAmount != undefined ?
                        <div style={styles.statCard('#a855f7')}>
                            <p style={styles.statValue}>
                                {numberWithCommas(userProfile.pendingAmount)}
                            </p>
                            <p style={styles.statLabel}>Total pending {props.x == 1 ? `for uid_${props.second_page}` : ''}</p>
                        </div>
                        : <Skeleton style={{ width: '160px', height: '70px', borderRadius: '12px' }} />}
                    {userProfile.withdrawalsLength != undefined ?
                        <div style={styles.statCard('#14b8a6')}>
                            <p style={styles.statValue}>
                                {numberWithCommas(userProfile.withdrawalsLength)}
                            </p>
                            <p style={styles.statLabel}>Count pending</p>
                        </div>
                        : <Skeleton style={{ width: '160px', height: '70px', borderRadius: '12px' }} />}
                </div>

                <div style={styles.tableContainer}>
                    <p style={styles.tableTitle}>Pending Offers</p>
                    <div>
                        <div style={styles.tableHeaderRow}>
                            <div style={styles.tableHeaderCell('50px')}>ID</div>
                            <div style={styles.tableHeaderCell('250px')}>Name</div>
                            <div style={styles.tableHeaderCell('100px')}>Wall</div>
                            <div style={styles.tableHeaderCell('150px')}>Amount</div>
                            <div style={styles.tableHeaderCell('150px')}>Release Time</div>
                            <div style={styles.tableHeaderCell('100px', '100px')}>Release</div>
                            <div style={styles.tableHeaderCell('100px', '100px')}>Check</div>
                        </div>
                    </div>

                    {earnings.map((earning, i) => {
                        return (
                            <div key={earning.id} style={styles.tableRow}>
                                <div style={styles.tableCell('50px')}>{earning.id || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={styles.tableCellPrimary('250px')}>{earning.name || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={styles.tableCell('100px')}>{earning.wall || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={styles.tableCell('150px')}>{earning.amount || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={styles.tableCell('150px')}>{earning.pending_time || <Skeleton style={{ width: '30px' }} />}</div>
                                <div
                                    onClick={() => {
                                        setAlert({ show: true, user_id: earning.user_id, offer_id: earning.id, name: earning.name })
                                    }}
                                    style={styles.actionButton('#3fb950', 'rgba(63,185,80,0.1)', '#3fb950')}
                                >{earning.id == undefined ? <Skeleton style={{ width: '30px' }} /> : 'Release'}</div>
                                <Link to={`/pluto/user/${earning.user_id}`} style={styles.actionButton('#58a6ff', 'rgba(88,166,255,0.1)', '#58a6ff')}>{earning.id == undefined ? <Skeleton style={{ width: '30px' }} /> : 'Check User'}</Link>
                            </div>
                        )
                    })}
                </div>
                {pageNumber == -1 ? <Skeleton style={{ width: '100%' }} /> : <PaginationPluto pageNumber={pageNumber} requestNewList={(page) => {
                    canUsePagination(false)
                    setEarnings([0, 0, 0, 0, 0])
                    socket.emit('getPendingOffersAdmin', {
                        username_like: username,
                        for_user: props.second_page,
                        page,
                        today,
                    })
                }} />}

            </div>

        </SkeletonTheme>
    )
}
function getPathNames() {

}
export default PlutoPendingOffers
